import { Controller } from "stimulus";
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["select", "button"];

  connect() {
    new Choices(this.selectTarget, {
      searchFields: ['label', 'value', 'customProperties'],
      classNames: {
        containerOuter: "choices w-100"
      },
      maxItemCount: 20,
      removeItemButton: true
    });

    this.buttonTarget.addEventListener("click", e => {
      const coinIds = Array.from(
        this.selectTarget.querySelectorAll("option:checked"),
        e => e.value
      );
      this._reloadPage(coinIds);
    });
    // Unhide
    this.buttonTarget.style.display = "";
  }

  _reloadPage(coinIds) {
    window.location.search = `?coin_ids=${coinIds.join(",")}`;
  }
}
